import { VsSeperator, MatchTime, MatchTeamsContainer } from "./styles";
import { MatchemMatchPickerTeam } from "./MatchemMatchPickerTeam";
import { format } from "date-fns-tz";
import { Pick } from "model/Pickem/Pickem";
import { Match } from "model/Match/Match";
import { getRosterDriverIds, getRosterId } from "model/Roster/Roster";
import { getNumTeams } from "model/Match/MatchTeams";

interface Props {
  match: Match;
  tournamentId: string;
  priorMatches: Match[];
  currentPick: Pick;
  updatePick: (rosterId: string | undefined) => void;
}

export const MatchemMatchPicker = ({
  match,
  tournamentId,
  priorMatches,
  currentPick,
  updatePick,
}: Props) => {
  const numTeams = getNumTeams(match.teams);
  const matchTime = format(new Date(match.startTimeMs), "HH:mm");

  const rosterScope = match.teams.scope;
  return (
    <MatchTeamsContainer>
      <MatchTime>{matchTime}</MatchTime>
      {match.teams.rosters.map((roster, i) => {
        const rosterId = getRosterId(roster);
        if (!rosterId) {
          return <></>;
        }

        const rosterDriverIds = getRosterDriverIds(roster, rosterScope) ?? [];
        return (
          <>
            <MatchemMatchPickerTeam
              key={`${i}-${rosterId}`}
              rosterId={rosterId}
              rosterDriverIds={rosterDriverIds}
              tournamentId={tournamentId}
              priorMatches={priorMatches}
              currentPick={currentPick}
              updatePick={updatePick}
            />
            {i + 1 < numTeams && <VsSeperator>vs</VsSeperator>}
          </>
        );
      })}
    </MatchTeamsContainer>
  );
};
